import { useAuth0 } from "@auth0/auth0-react";
import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";

export const Login = () => {
  const { loginWithPopup } = useAuth0();

  return (
    <Container>
      <Typography
        variant="h6"
        style={{
          color: "white",
        }}
      >
        Crypto App
      </Typography>
      <Button
        style={{ width: "20rem", marginTop: "1rem" }}
        onClick={() => loginWithPopup()}
        size="large"
        variant="contained"
        color="primary"
      >
        Login
      </Button>
    </Container>
  );
};

const Container = styled.div`
  background-color: ${(props) => props.theme.palette.background.default};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  flex: 1;
`;
